import { ApolloError, gql, useMutation } from "@apollo/client";
import {
  CrCorporationInput,
  CrCorporationMutation,
  CrCorporationMutationVariables,
} from "../generated/graphql";

export interface ICrCorporationFormProps {
  phone?: string;
  address?: string;
  name: string;
  serviceId?: string;
  mainCategory?: any[];
  operationFrom?: string;
  operationTo?: string;
  origin?: string
  holiday?: string;
  deliveryLimitQuantity?: number;
}
const CR_CORPORATION_MUTATION = gql`
  mutation crCorporation($input: CrCorporationInput!) {
    crCorporation(input: $input) {
      ok
      err
      createdId
    }
  }
`;

export const useCrCorporation = (
  onCompleted?: (data: CrCorporationMutation) => void,
  onError?: (error: ApolloError) => void
) => {
  return useMutation<CrCorporationMutation, CrCorporationMutationVariables>(
    CR_CORPORATION_MUTATION,
    {
      onCompleted,
      onError,
    }
  );
};
